








import { Component, Prop, Vue } from 'vue-property-decorator'

type Data = {
  message: string
  level: Level
  timeout: number
}

type Level = 'success' | 'info' | 'warning' | 'error'

@Component
export default class Flash extends Vue {
  @Prop({ default: '' }) message!: string
  @Prop({ default: 'success' }) level!: Level
  @Prop({ default: 5000 }) timeout!: number

  data: Data = {
    message: '',
    level: 'success',
    timeout: 5000,
  }

  show = false

  created(): void {
    if (this.message) {
      this.flash({
        message: this.message,
        level: this.level,
        timeout: this.timeout,
      })
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.events.$on('flash', (data: Data) => {
      this.flash(data)
    })
  }

  get closeButtonColor(): string {
    const mapping = {
      success: 'primary--text',
      warning: 'secondary--text',
      error: 'primary--text',
      info: 'primary--text',
    }

    if (this.data.level in mapping) {
      return mapping[this.data.level]
    }

    return 'primary--text'
  }

  flash(data: Data): void {
    this.data.message = data.message
    this.data.level = data.level
    this.data.timeout = data.timeout

    this.show = true

    this.hide()
  }
  hide(): void {
    setTimeout(() => {
      this.show = false
    }, this.data.timeout)
  }
}
